import script from "./web-article-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-article-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-article-detail.vue?vue&type=style&index=0&id=b2246514&lang=scss"

const __exports__ = script;

export default __exports__